import { wait } from '../utils/wait';
import { useRefetch } from '../composables/use-refetch';

/**
 * When logging in from within the log-in wall, the redirect URL loads lokarb in an iframe. We don't want that, so we
 * reload the complete page to load all the data we need and get rid of the login wall, giving our users the full
 * ✨logged-in experience✨
 */
export default async function reloadParentIfIFrame() {
    if (window.self !== window.top) {
        const { shouldRefetchEverythingOnReload } = useRefetch();
        shouldRefetchEverythingOnReload.value = true;
        window.top.location.reload();

        // Stall to give parent frame time to reload
        await wait(10000);
    }
}
